import { Box, Typography, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        background: "linear-gradient(to bottom, #ffffff, #fff1e0, #ffffff)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* soft glow layer */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom, rgba(247,127,0,0.18), transparent, rgba(247,127,0,0.25))",
          zIndex: 0,
        }}
      />

      {/* CONTENT */}
      <Box sx={{ zIndex: 1, px: 3 }}>
        <Typography
          sx={{
            fontSize: { xs: "80px", md: "120px" },
            fontWeight: 900,
            lineHeight: 1,
            background: "linear-gradient(90deg, #f77f00, #fcbf49, #ffb703)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            textShadow: "0 0 35px rgba(247,127,0,0.4)",
          }}
        >
          404
        </Typography>

        <Typography
          sx={{
            mt: 2,
            maxWidth: 520,
            fontSize: { xs: "16px", md: "20px" },
            color: "#555",
          }}
        >
          Oops! The page you’re looking for doesn’t exist or might have been
          moved.
        </Typography>

        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          sx={{
            mt: 4,
            px: 5,
            py: 1.3,
            borderRadius: "999px",
            borderColor: "#f77f00",
            color: "#f77f00",
            fontWeight: 600,
            textTransform: "none",
            backgroundColor: "rgba(255,255,255,0.6)",
            backdropFilter: "blur(6px)",
            "&:hover": {
              borderColor: "#e76f00",
              backgroundColor: "rgba(247,127,0,0.1)",
            },
          }}
          onClick={() => navigate("/HomePage")}
        >
          Back to Home
        </Button>
      </Box>

      {/* bottom accent lines */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: "2px",
          background:
            "linear-gradient(to right, transparent, #f77f00, transparent)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: "6px",
          filter: "blur(6px)",
          background:
            "linear-gradient(to right, transparent, rgba(247,127,0,0.7), transparent)",
        }}
      />
    </Box>
  );
};

export default NotFound;
